import { render } from "./UnwrappedNFRs.vue?vue&type=template&id=d0c40432"
import script from "./UnwrappedNFRs.vue?vue&type=script&lang=js"
export * from "./UnwrappedNFRs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__